import { driver } from '@leagueplatform/masonry';
import { DEFAULT_NAMESPACE } from '@leagueplatform/masonry-engine';
import { registerPreAuthorizationsMasonryRenderers } from '@leagueplatform/pre-authorizations';
import { MasonryAccordionItemRendererOverride } from 'components/masonry-accordion-item-renderer-override/masonry-accordion-item-renderer-override.component';
import { MasonryButtonRendererOverride } from 'components/masonry-button-renderer-override/masonry-button-renderer-override.component';
import { appDeeplinkActionHandler } from 'utils/geisinger-sso';

// Renderer namespace the Plan Switcher submit button is tagged with (services:
// geisinger/planSwitcher/submitButtonTrailing). Scoping the override to it means
// it only ever receives that button, so no other screen's buttons are touched.
// Must match the `namespace` on that YAML node.
const PLAN_SWITCHER_NAMESPACE = 'geisinger_plan_switcher';

export const initMasonryRegistry = () => {
  // Global: Geisinger SSO tiles live on several screens (Get care, Pharmacy,
  // Home, Journey), so their link is handled for the whole app.
  driver.actionController.overrideHandler(
    'deeplink',
    'default',
    appDeeplinkActionHandler,
  );

  // Global: geisinger accordion styling (used by the Plan Switcher AND the
  // Premium Payments FAQ), so this stays on the default namespace.
  driver.nodeRendererRegistry.overrideRenderer(
    'accordionItem',
    DEFAULT_NAMESPACE,
    MasonryAccordionItemRendererOverride,
  );

  // Plan Switcher only: the trailing "View plan" submit goes full-width on
  // mobile; see the override for why this lives at the renderer seam.
  driver.nodeRendererRegistry.overrideRenderer(
    'button',
    PLAN_SWITCHER_NAMESPACE,
    MasonryButtonRendererOverride,
  );

  // The Prior Authorizations capability registers nothing on import — its
  // renderers have to be pointed at the namespaces the Geisinger Masonry trees
  // emit. Its own docs ask for this to happen here, alongside the other
  // registry setup, so it runs once before any tree mounts.
  registerPreAuthorizationsMasonryRenderers({
    authorizations: 'geisinger_authorizations',
    pagination: 'geisinger_authorizations_pagination',
    details: 'geisinger_authorization_details',
    // The learn-more stack arrives under the engine default namespace.
    learnMore: DEFAULT_NAMESPACE,
  });
};
